import {createReducer, on} from '@ngrx/store';
import * as StoryActions from './story.actions';
import {Event, State} from 'gamesis-story-client';
import {unauthenticated} from '../app/app.actions';
import {exitCampaign} from '../campaigns/campaign.actions';

export interface ActivityState {
    [character: string]: State;
}

export interface StoryState {
    events: Event[];
    count: number | undefined;
    activity: ActivityState;
    initialized: boolean;
    loading: boolean;
    error: any;
}

const initialState: StoryState = {
    events: [],
    count: undefined,
    initialized: false,
    activity: {},
    loading: false,
    error: null
};

const _storyReducer = createReducer(
    initialState,
    on(StoryActions.loadEvents,
        StoryActions.synchronize,
        StoryActions.round,
        StoryActions.comment,
        StoryActions.act,
        StoryActions.speak,
        StoryActions.react,
        StoryActions.rollDice,
        StoryActions.rollStoredDice,
        StoryActions.addImages,
        state => ({
            ...state,
            loading: true
        })),
    on(StoryActions.loadEventsSuccess,
        StoryActions.timelineCreate,
        StoryActions.timelineUpdate,
        StoryActions.timelineDelete,
        StoryActions.synchronizeSuccess,
        StoryActions.updateEventSuccess,
        StoryActions.reactSuccess,
        StoryActions.deleteEventSuccess,
        StoryActions.createEventSuccess,
        StoryActions.rollSuccess,
        StoryActions.rollFailure,
        state => ({
            ...state,
            loading: false
        })),
    on(StoryActions.loadEventsSuccess, (state, {count, events}) => {
        let current: Event[] = [...state.events];
        if (events) {
            events.forEach(event => {
                const index = current.findIndex(e => e.id === event.id);
                if (index >= 0) {
                    current[index] = event;
                } else {
                    // new event. add to array
                    current.push(event);
                }
            });
            current = current.sort(function (eventA: Event, eventB: Event) {
                return eventA.created > eventB.created ? 1 : -1;
            });
        }

        return ({
            ...state,
            events: current,
            count: count,
            initialized: true
        });
    }),
    on(StoryActions.timelineCreate, (state, {event, count}) => {
        const events: Event[] = [...state.events];
        events.push(event);
        return ({
            ...state,
            events: events,
            count: count
        });
    }),
    on(StoryActions.timelineUpdate, (state, {event}) => {
        const events: Event[] = [...state.events];
        const index = events.findIndex(e => e.id === event.id);
        if (index >= 0) {
            events[index] = event;
        }
        return ({
            ...state,
            events: events
        });
    }),
    on(StoryActions.timelineDelete, (state, {id, count}) => {
        const events: Event[] = [...state.events];
        events.splice(events.findIndex(event => event.id === id), 1);
        return ({
            ...state,
            events: events,
            count: count
        });
    }),
    on(StoryActions.eventFailure, (state, {error}) => ({...state, loading: false, error})),
    on(StoryActions.initialize, exitCampaign, unauthenticated, (state) => initialState),
    on(StoryActions.stateUpdate, (storyState, {character, state}) => {
        const activity = {...storyState.activity};
        activity[character] = state;
        return ({...storyState, activity: activity});
    }),
    on(StoryActions.stateIdle, (state, {character}) => {
        const activity = {...state.activity};
        delete activity[character];
        return ({...state, activity: activity});
    }),
);

export function storyReducer(state, action) {
    return _storyReducer(state, action);
}
